import React from 'react';
import { ParticipationRequestsContainer } from '../../containers';

const ParticipationRequestsPage = () => <ParticipationRequestsContainer />;

export default ParticipationRequestsPage;
